// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GnbJ0-wCbnpt2nZev1VI9"};